export default "__VITE_ASSET__05a29dc3__"